// extracted by mini-css-extract-plugin
export default {"homePage":"Home_homePage__SPhdt","redBorderDecorator":"Home_redBorderDecorator__0SzaY"};